import { ReactNode, useRef } from 'react';

import { useOnClickOutside } from '@speeki/react-hooks';

import { DropdownWrapper } from './Dropdown.styled';

interface DropdownProps {
    children: ReactNode;
    className?: string;
    setIsOpen: (isOpen: boolean) => void;
}

export const Dropdown = ({ children, className, setIsOpen }: DropdownProps) => {
    const dropdownRef = useRef(null);
    useOnClickOutside(dropdownRef, () => setIsOpen(false));

    return (
        <DropdownWrapper className={className} ref={dropdownRef}>
            {children}
        </DropdownWrapper>
    );
};
